import { setupIonicReact, useIonLoading } from '@ionic/react'
import { createContext, useContext, useEffect, useState, type ReactNode } from 'react'
import { isMobile } from 'react-device-detect'
import { useHistory } from 'react-router'
import { COUNTRY } from '../const/constants'
import { getEntApp } from '../services/api/dig-business-sales'
import { getSettings } from '../services/api/dig-documents-manager'
import { authenticateItec, getPsrPermissions, tokenIdp } from '../services/api/settings'

const AppContext = createContext({})

export const useAppContext = () => useContext(AppContext)

interface Props {
  children: ReactNode
}

export const AppContextProvider = ({ children }: Props) => {
  const [settings, setSettings] = useState({})
  const [environment, setEnvironment] = useState({})
  const [user, setUser]: any = useState({})
  const [present, dismiss] = useIonLoading()
  const [blockNavigation, setBlockNavigation] = useState(false)
  const [loginScreen, setLoginScreen] = useState(false)
  const [permissions, setPermissions] = useState(null)

  const history = useHistory()

  setupIonicReact({
    backButtonDefaultHref: '#',
    swipeBackEnabled: false, // also prevent swiping back on either platform
    hardwareBackButton: false // this is what you need (android only)
  })

  const checkNomPermissions = async (primarymsisdn: string) => {
    try {
      const tokenItec = await authenticateItec()
      const data = await getPsrPermissions(tokenItec, primarymsisdn)
      setPermissions(data.Permissions)
    } catch (error: any) {
      console.log(error)
    }
  }

  const newLoginUY = async (primarymsisdn: string) => {
    try {
      const entAppData = await getEntApp(primarymsisdn)
      if (!entAppData.success) throw new Error('No se pudo obtener entApp')
      const userData = { posNumber: entAppData.response.primarymsisdn, extCode: entAppData.response.entApp }
      setUser({ ...user, ...userData })
      localStorage.setItem('userWithIDP', JSON.stringify({ ...user, ...userData }))
      return history.push('/procedures')
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (
      !location.href.includes('/invalid-session') &&
      !location.href.includes('/loginPY') &&
      !location.href.includes('/loginIDP') &&
      !location.href.includes('/check')
    )
      (async function () {
        present({
          message: `Validando sesión. <br/> Esperá por favor.`
        })
        try {
          const settingsResponse = await getSettings()
          if (!settingsResponse.success) throw new Error('No se pudieron obtener las settings')
          const frontSettings = settingsResponse.response
          setSettings(frontSettings)
          localStorage.setItem('settings', JSON.stringify(frontSettings))

          if (frontSettings.country !== COUNTRY.PY) {
            const response = await tokenIdp()
            if (frontSettings.country === COUNTRY.UY) await newLoginUY(response.primarymsisdn)
            else checkNomPermissions(response.primarymsisdn)
          }

          const storageData: any =
            frontSettings.country === COUNTRY.PY ? localStorage.getItem('user') : localStorage.getItem('userWithIDP')
          if (storageData) return setUser(JSON.parse(storageData))

          if (frontSettings.country === COUNTRY.PY) location.href = '/loginPY'
          else if (frontSettings.country === COUNTRY.AR) location.href = '/loginIDP'
        } catch (error) {
          console.log(error)
          location.href = '/invalid-session'
        } finally {
          dismiss()
        }
      })()
  }, [])

  const contextValue = {
    settings,
    environment,
    user,
    permissions,
    setUser,
    blockNavigation,
    isMobile,
    loginScreen,
    setSettings,
    setEnvironment,
    setBlockNavigation,
    setLoginScreen,
    checkNomPermissions
  }

  return <AppContext.Provider value={contextValue}>{children}</AppContext.Provider>
}

export default AppContext
